import { FETCH_MATCHES } from './actionTypes'

export const updateMatches = ({ matches, sportId, leagueId }) => ({
  type: FETCH_MATCHES,
  payload: {
    list: matches,
    sportId,
    leagueId,
  },
})
